<template>
  <div class="n-list-subtitle">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'NListSubtitle',
};
</script>